<div *ngIf="result.visible$ | async" class="popup">
  <ng-container *ngIf="timer.timers.total as total">
    <ng-container *ngIf="timer.timers.limit as limit">
      <div [class.success]="result.success || total.done" class="popup-content">
        <div class="filler"></div>

        <div class="popup-message">
          <div class="title">
            {{'result.nice' | translate}}
          </div>
          <div>
            {{'result.target' | translate}}
            <strong> {{total.percent}}% </strong>
            {{'result.reach' | translate}}
            <strong>({{ limit.stopWatch$ | async }}
              {{'result.of' | translate}}
              {{total.max | toMinutes | date:'m'}}
              {{'result.min' | translate}})</strong>
            <span>.</span>
            <br>
            <span *ngIf="total.percent < 100">
              {{'result.question' | translate}}
            </span>
            <ng-content></ng-content>
          </div>

          <svg height="22" width="30">
            <polygon fill="#FFFFFF" points="3,0 27,0 15,16" stroke="#FFFFFF" stroke-linejoin="round" stroke-width="5" />
          </svg>

          <inka-mascot-happy class="mascot" />
        </div>

        <div class="filler x8"></div>

        <div class="actions">
          <button (click)="result.hide(false)" *ngIf="!limit.done" class="accept">
            {{'button.action.continue' | translate}}
          </button>
          <button (click)="result.hide(true)" *ngIf="!result.manualExit && !limit.done" class="decline">
            {{'button.action.another' | translate}}
          </button>
          <button (click)="exit()" class="decline">
            {{'button.action.exit' | translate}}
          </button>
        </div>
      </div>
    </ng-container>
  </ng-container>

</div>